(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const target = new Date(root.dataset.countdownTarget).getTime();
    const fields = { days: root.querySelector('[data-days]'), hours: root.querySelector('[data-hours]'), minutes: root.querySelector('[data-minutes]') };
    const render = () => {
      const distance = Number.isFinite(target) ? Math.max(0, target - Date.now()) : 0;
      fields.days.textContent = String(Math.floor(distance / 86400000)).padStart(2, '0');
      fields.hours.textContent = String(Math.floor(distance / 3600000) % 24).padStart(2, '0');
      fields.minutes.textContent = String(Math.floor(distance / 60000) % 60).padStart(2, '0');
    };
    render();
    root._blackCountdown = window.setInterval(render, 30000);
  };
  document.querySelectorAll('[data-black-estrelas]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-black-estrelas]')));
  document.addEventListener('shopify:section:unload', (event) => { const root = event.target.querySelector('[data-black-estrelas]'); if (root?._blackCountdown) clearInterval(root._blackCountdown); });
})();
